import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { PRIMENG_ES } from '../../public/assets/primeng-es';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { Spinner } from './_core/spinner';
import { BrandingService } from './_core/branding.service';
import { BrandingUnavailable } from './branding-unavailable/branding-unavailable';

@Component({
  selector: 'app-root',
  imports: [BlockUIModule, ProgressSpinnerModule, ToastModule, RouterOutlet, BrandingUnavailable],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly title = signal('Oficina Virtual GGM');

  private primeNgConfig = inject(PrimeNG);
  public spinner = inject(Spinner);
  protected readonly $branding = inject(BrandingService);

  ngOnInit(): void {
    this.primeNgConfig.setTranslation(PRIMENG_ES);
  }
}
